<template>
  <v-list-item :style="{ background: index % 2 == 0 ? '#efefef' : 'inherit' }">
    <v-list-item-action @click="viewImage(received.sticker)">
      <v-btn icon>
        <v-icon>{{ "remove_red_eye" }}</v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ received.name }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action @click="removeSticker(received.id)">
      <v-btn icon>
        <v-icon>{{ "delete" }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: "StickerCard",
  props: ["received", "index"],
  methods: {
    viewImage(sticker) {
      this.$emit("openView", sticker);
    },
    removeSticker(id) {
      this.$http.delete("rest/stickers/" + id).then(() => {
        this.$emit("receiveStickers");
      });
    },
  },
};
</script>
